import { Resource } from './lib/Resource';
export * from './lib/components/ResourceForm';
export default Resource;
